/**
 * User: liliana
 * Date: 1/5/15
 * Time: 4:12 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

/**
 * pointerevents.js - commonjs entries files for jQuery PointerEvents dependencies
 * @link https://github.com/jquery/PointerEvents
 */

'use strict';

var scopeName = 'PointerEventsPolyfill';
window[scopeName] = window[scopeName] || {};

// ---------------------------------------------------
// Dependencies

require('pepjs');
require('./jquery.pointerHooks');



//////////////////
// WEBPACK FOOTER
// ./assets/js/thirdParty/pointerevents.js
// module id = 2300
// module chunks = 62